import { ColDef, ColGroupDef } from 'ag-grid-community';
import { t } from 'i18next';
import { RECURRENCE } from 'routes/HumanResourcesModule/business/definitions';
import { TEXT_FILTER } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/defaultColDefs';
import {
    agentCellRendererSelectorGetter,
    getGroupedAgentColumn,
} from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/agentColumnHelpers';
import { recurrentFormatter } from 'routes/HumanResourcesModule/Settings/HrPositionMapping/helpers/gridHelpers';
import {
    createRealizedColumn,
    createLoadedSimulatedColumn,
    getAmountColumns,
} from 'routes/HumanResourcesModule/Simulation/helpers/gridHelpers';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import { PAY_COMPONENT } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/helpers/constants';
import { getGroupedOrgChartHrColumn } from 'routes/HumanResourcesModule/components/HrDataGrid/helpers/orgChartHrColumnHelpers';
import { SemiTreatmentHypothesis } from 'routes/HumanResourcesModule/Simulation/helpers/hooks/semiTreatment';
import { sortPayComponents } from 'routes/HumanResourcesModule/PayState/PayStateSynthesis/PayComponentSalaryMass/helpers/dataHelpers';
import { getMantyStatusColumn } from 'routes/HumanResourcesModule/PayState/helpers/colDefinitions';

export const getColDefs = ({
    simulationInitDate,
    simulationStart,
    simulationEnd,
    semiTreatmentHypothesesData,
}: {
    simulationInitDate: SimulationDateString;
    simulationStart: SimulationDateString;
    simulationEnd: SimulationDateString;
    semiTreatmentHypothesesData: SemiTreatmentHypothesis[];
}): (ColDef | ColGroupDef)[] => {
    const betweenCurrentAndSimulatedDateColumnGetters = [
        createRealizedColumn,
        createLoadedSimulatedColumn,
    ];
    const pastDateColumnGetters = [createRealizedColumn];
    const simulatedDateColumnGetters = [createLoadedSimulatedColumn];

    return [
        getGroupedOrgChartHrColumn(),
        getGroupedAgentColumn(
            true,
            agentCellRendererSelectorGetter(
                semiTreatmentHypothesesData,
                true,
                simulationInitDate,
            ),
        ),
        getMantyStatusColumn(),
        {
            ...TEXT_FILTER,
            headerName: t('humanResources.settings.recurrence'),
            field: RECURRENCE,
            rowGroup: false,
            enableRowGroup: true,
            hide: true,
            valueFormatter: recurrentFormatter,
            filterValueGetter: recurrentFormatter,
        },
        {
            ...TEXT_FILTER,
            headerName: t('humanResources.simulation.payComponent'),
            field: PAY_COMPONENT,
            enableRowGroup: true,
            pinned: 'left',
            sort: 'asc',
            comparator: sortPayComponents,
        },
        ...getAmountColumns({
            simulationStart,
            simulationEnd,
            betweenCurrentAndSimulatedDateColumnGetters,
            pastDateColumnGetters,
            simulatedDateColumnGetters,
        }),
    ];
};
